import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import getLocale from '../../i18n/getLocale';
class StaffsCerficationsOutdatedIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.formatExpired = this.formatExpired.bind(this);
    this.formatName = this.formatName.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/certificados/vencimento', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }
  formatExpired (cell, row) {
    var data = this.state.data;
    var expire_color = '';
    var expire_status_str = '';

    data.map(function(d, index){
      if (d.expire_status_str == cell) {
        expire_color = d.expire_color;
        expire_status_str = d.expire_status_str;
      }
    });

    var span = (
      <span className={'label label-' + expire_color}>
        {expire_status_str}
      </span>
    );

    return span;
  }
  formatName (cell, row) {
    var data = this.state.data;
    var staff = '';
    var staff_id = 0;

    data.map(function(d, index){
      if (d.staff == cell) {
        staff = d.staff;
        staff_id = d.staff_id;
      }
    });

    var url = '/funcionario/editar/' + staff_id;

    var link = (
      <Link to={url}>
        {staff}
      </Link>
    );

    return link;

  }
  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.semTripulantes, sizePerPage: 100, sizePerPageList: [{text: '10', value: 10}, {text: '25', value: 25}, {text: '50', value: 50}, {text: '100', value: 100}]}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>#</TableHeaderColumn>

        <TableHeaderColumn dataField="staff" dataAlign="center" dataFormat={this.formatName} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.Tripulante}</TableHeaderColumn>
        
        <TableHeaderColumn dataField="certification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.Certificados}</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_time_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.Prazo}</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_status_str" dataAlign="center" dataFormat={this.formatExpired} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='90'>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.Expirado}?</TableHeaderColumn>

        <TableHeaderColumn dataField="expire_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeCertificadosAVencerPorTripulante.tabela.DataDeExpiracao}</TableHeaderColumn>     
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffsCerficationsOutdatedIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsCerficationsOutdatedIndex.js